/**
 * Google Maps initialization script for WordPress
 * Supports multiple maps on a page.
 * Requires: googleMaps script enqueued with async+defer
 */

async function waitForGoogleMaps() {
	return new Promise((resolve) => {
		if (window.google && window.google.maps) return resolve()
		const interval = setInterval(() => {
			if (window.google && window.google.maps) {
				clearInterval(interval)
				resolve()
			}
		}, 50)
	})
}

export async function initMaps() {
	const elements = document.querySelectorAll('[data-address]')
	if (!elements.length) return

	// Wait for the Google Maps API to be available
	await waitForGoogleMaps()

	// Dynamically import Maps and Marker libraries (modern API)
	const { Map } = await google.maps.importLibrary('maps')
	const { Marker } = await google.maps.importLibrary('marker')

	const styles = [
		{ elementType: "geometry", stylers: [{ color: "#f5f2e8" }] },
		{ elementType: "labels.icon", stylers: [{ visibility: "off" }] },
		{ elementType: "labels.text.fill", stylers: [{ color: "#6b5c2b" }] },
		{ elementType: "labels.text.stroke", stylers: [{ color: "#ffffff" }] },
		{ featureType: "road", elementType: "geometry", stylers: [{ color: "#e0c97a" }] },
		{ featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#CFB054" }] },
		{ featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#bfa040" }] },
		{ featureType: "road.local", elementType: "labels.text.fill", stylers: [{ color: "#806b2a" }] },
		{ featureType: "water", elementType: "geometry", stylers: [{ color: "#d8c995" }] },
		{ featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#8c7a3a" }] },
		{ featureType: "landscape.man_made", elementType: "geometry.fill", stylers: [{ color: "#f2eddc" }] },
		{ featureType: "landscape.natural", elementType: "geometry.fill", stylers: [{ color: "#f7f2e3" }] },
		{ featureType: "poi", elementType: "geometry", stylers: [{ color: "#efe5c0" }] },
		{ featureType: "poi.park", elementType: "geometry.fill", stylers: [{ color: "#e6dcad" }] },
		{ featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#7f7132" }] },
		{ featureType: "transit", elementType: "geometry", stylers: [{ color: "#e4d29b" }] },
		{ featureType: "transit.station", elementType: "labels.text.fill", stylers: [{ color: "#a08833" }] },
	]

	const icon = {
		url: '/wp-content/themes/equilibrium-2025/dist/images/marker.png',
		scaledSize: new google.maps.Size(66.4, 76),
		origin: new google.maps.Point(0, 0),
		anchor: new google.maps.Point(33.2, 90),
	}

	// Initialize each map separately
	elements.forEach((el) => {
		const lat = parseFloat(el.dataset.lat)
		const lng = parseFloat(el.dataset.lng)
		const address = el.dataset.address

		if (!lat || !lng) return

		const map = new Map(el, {
			center: { lat, lng },
			zoom: 17,
			styles,
			mapTypeControl: false,
			streetViewControl: false,
			zoomControl: true,
			fullscreenControl: false,
		})

		new Marker({
			position: { lat, lng },
			map,
			title: address,
			icon,
		})
	})
}

export const map = () => {
	document.addEventListener('DOMContentLoaded', () => {
		initMaps().catch((err) => console.error('Google Maps failed to initialize:', err))
	})
}

export default () => { }